import { Grid, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ProductButton({ title, subtitle = null, route = null }) {
    const navigate = useNavigate();

    const handleAction = () => {
        if (route != null) {
            navigate(`/${route}`);
        }
    };

    return (
        <Grid className={""} id="product-button-grid" variant="outlined" onClick={handleAction} >
            <div className="product-card p-3">
                <Grid>
                    <Tooltip title={title} arrow>
                        <h4 className="limit-2-lines">{title}</h4>
                    </Tooltip>
                </Grid>
                <Grid>
                    {subtitle &&
                        <Tooltip title={subtitle} arrow>
                            <p className="limit-3-lines">{subtitle}</p>
                        </Tooltip>
                    }
                </Grid>
            </div>
        </Grid>
    );
}
